import(/* webpackMode: "eager" */ "/home/foneorders.com/app/src/app/(landing)/cookie/page.tsx");
